export const CHANGE_NAVIGATION_SHOW = 'CHANGE_NAVIGATION_SHOW';